import { Tag } from 'antd';
import type { TagProps } from 'antd/es/tag';
import classNames from 'classnames';
import { FC } from 'react';

import { NotificationTagLabel } from '../../constants/NotificationTag';
import { MemoTag } from '../../graphql.generated';

import styles from './styles.module.less';

type NotificationTagProps = TagProps & {
  tag: MemoTag;
};

const NotificationTag: FC<NotificationTagProps> = ({
  tag,
  className,
  ...rest
}) => {
  return (
    <Tag className={classNames(styles.tag, className)} {...rest}>
      {NotificationTagLabel[tag]}
    </Tag>
  );
};

NotificationTag.displayName = 'NotificationTag';

export default NotificationTag;
